import React, { useEffect, useRef, useState } from "react";

export default function GameTimer({ leftTime, totalSeconds = 30 }) {
  const [timeLeft, setTimeLeft] = useState(totalSeconds);
  const intervalRef = useRef(null);

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (typeof leftTime !== "number") return;

    setTimeLeft(leftTime);

    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [leftTime]);

  /* ================= SVG ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / totalSeconds));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  return (
    <div className="teenpatti-base-timer">
      <svg viewBox="0 0 100 100" className="base-timer__svg">
        <g className="base-timer__circle">
          <circle
            cx="50"
            cy="50"
            r="45"
            className="base-timer__path-elapsed"
          />
          <path
            strokeDasharray={`${Math.round(dash)} ${Math.round(CIRC)}`}
            className={`base-timer__path-remaining ${timerColor}`}
            d="
              M 50, 50
              m -45, 0
              a 45,45 0 1,0 90,0
              a 45,45 0 1,0 -90,0
            "
          />
        </g>
      </svg>

      <span className="base-timer__label" style={{paddingTop: "10px"}}>
        {leftTime === 1 ? 0 : leftTime}
      </span>
    </div>
  );
}
